//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client.types';
import { getAxios, getBaseUrl } from './helpers';

export function enable(dto: Types.PrivilegedModeTotpEnableRequestDto, config?: AxiosRequestConfig | undefined): Promise<Types.PrivilegedModeTotpEnableResponseDto> {
    let url_ = getBaseUrl() + "/api/privileged-mode/totp/enable";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializePrivilegedModeTotpEnableRequestDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigEnable,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigEnable?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processEnable(_response);
    });
}

function processEnable(response: AxiosResponse): Promise<Types.PrivilegedModeTotpEnableResponseDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initPrivilegedModeTotpEnableResponseDto(resultData200);
        return Promise.resolve<Types.PrivilegedModeTotpEnableResponseDto>(result200);

    } else if (status === 429) {
        const _responseText = response.data;
        let result429: any = null;
        let resultData429  = _responseText;
        result429 = Types.initProblemDetails(resultData429);
        return throwException("A server side error occurred.", status, _responseText, _headers, result429);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.PrivilegedModeTotpEnableResponseDto>(null as any);
}
let _requestConfigEnable: Partial<AxiosRequestConfig> | null;
export function getEnableRequestConfig() {
  return _requestConfigEnable;
}
export function setEnableRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigEnable = value;
}
export function patchEnableRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigEnable = patch(_requestConfigEnable ?? {});
}